import React, { Component } from "react";
import maskText from "../helpers/maskText";
import moment from "moment";
import "moment/locale/tr";

moment.locale("tr");
export default class OrderDetailInfo extends Component {
  render() {
    return (
      <table
        className={"table table-bordered table-hover"}
        style={{ marginTop: 20 }}
      >
        <thead>
          <tr>
            <td colspan={2}>Sipariş Detayı</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Sipariş No:</strong>
            </td>
            <td>
              {
                this.props.order[this.props.customer ? "order" : "orderEnquiry"]
                  .c_number
              }
            </td>
          </tr>
          <tr>
            <td>
              <strong>Sipariş Tarihi:</strong>{" "}
              {moment(
                this.props.order[this.props.customer ? "order" : "orderEnquiry"]
                  .created_at
              ).format("DD/MM/YYYY")}
            </td>
            <td>
              <strong>Ödeme Metodu:</strong>{" "}
              {this.props.customer
                ? this.props.order[
                    this.props.customer ? "order" : "orderEnquiry"
                  ].payment
                : maskText(
                    this.props.order[
                      this.props.customer ? "order" : "orderEnquiry"
                    ].payment,
                    1
                  )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderDetailInfo.js